import { takeLatest, put, call } from 'redux-saga/effects';
import {
    GET_ALLDEFAULTPRODUCT,
    getAllDefaultProductFailure,
    getAllDefaultProductSuccess,
    PRODUCT_TEMPLATE_EDIT,
    ProductTemplateEditSuccess,
    ProductTemplateEditFailure

   
} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from "../../../components/Utils/httpHelper";
import {  REPORT,CORE_API } from '../../../config';

export function* getAllDefaultProductSaga(action) {
    let requestURL = `${CORE_API}/producttemplate/all`;
    try {
        const result = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        //request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS }
        yield put(getAllDefaultProductSuccess(result.data));
    } catch (err) {
        yield put(getAllDefaultProductFailure(err))
    }
}
export function* getIAllDefaultProductListSaga() {
    yield takeLatest(GET_ALLDEFAULTPRODUCT, getAllDefaultProductSaga);
}


export function* putcorporateOnboardingDataEdit(action) {
    let requestUrl = `${CORE_API}/producttemplate/edit`;
    try {
        const editedProductTemplate = yield call(request, requestUrl, { data: action.data, method: 'PUT', headers: HTTP_HEADERS });
        yield put(ProductTemplateEditSuccess(editedProductTemplate.data))
    }
    catch (err) {
        yield put(ProductTemplateEditFailure(err))
    }
}
export function* productTemplateEdit() {
    yield takeLatest(PRODUCT_TEMPLATE_EDIT, putcorporateOnboardingDataEdit);
}



